import { call, select, put } from 'redux-saga/effects'

import actions from 'actions'
import api from 'services'
import { fetchEntity, fetchData, delay } from 'utils/sagas'
import { getChangedDraftDeals } from 'selectors/performance'

const { dealsBatchUpdate, performance, performanceTicketDetails, draftDealsCancel, resetErrorMessage } = actions

const fetchPerformance = fetchEntity.bind(
  null,
  performance,
  api.fetchPerformance
)

const fetchPerformanceTicketDetails = fetchEntity.bind(
  null,
  performanceTicketDetails,
  api.fetchPerformanceTicketDetails
)

const fetchDealsBatchUpdate = fetchData.bind(
  null,
  dealsBatchUpdate,
  api.dealsBatchUpdate
)

export function* loadPerformance(performanceId) {
  yield call(fetchPerformance, performanceId)
}

export function* loadPerformanceTicketDetails(performanceId) {
  yield call(fetchPerformanceTicketDetails, performanceId)
}

const getVersion = (state, performanceId) =>
  (state.entities.performances[performanceId] ? state.entities.performances[performanceId].version : 0)

export function* pollPerformanceTicketDetails(performanceId) {
  try {
    yield call(delay, 10000)
    const version = yield select(getVersion, performanceId)
    yield call(fetchPerformanceTicketDetails, performanceId, version)
  } catch (error) {
    return
  }
}

export function* acknowledgePerformance(performanceId, print) {
  yield call(api.acknowledgePerformance, performanceId, print)
}

export function* dealsBatchUpdateSaga() {
  const changedDraftDeals = yield select(getChangedDraftDeals)
  if (changedDraftDeals.length) {
    yield call(fetchDealsBatchUpdate, changedDraftDeals)
  } else {
    yield put(draftDealsCancel())
  }
}

export function* draftDealSuccessSaga() {
  yield put(resetErrorMessage())
  yield put(draftDealsCancel())
}

export function* draftDealsCancelSaga() {
  yield put(resetErrorMessage())
}



/** WEBPACK FOOTER **
 ** ./src/sagas/performance/performance-sagas.js
 **/